export const SET_PERMITS = 'SET_PERMITS';